import Vue from 'vue'
import VueGtag from 'vue-gtag'
import { initRouter } from '@/_standalone/plugins/vue-router'

export default function(ctx, inject, envName, routes) {
  const _envName = process?.env?.envName || envName
  const _router = ctx?.app?.router || initRouter(routes)
  const gaKey = 'G-E41DFGVLGP'
  const enable = _envName === 'staging' || _envName === 'master'

  if (enable) {
    Vue.use(
      VueGtag,
      {
        config: { id: gaKey }
      },
      _router
    )
  }
}
